import Frontpage from './Frontpage'

export default Frontpage
